import { instanceOfGrid } from "../../../lib/grid/instanceOfGrid.js";
import "react";
import "@perxis-auto/shared/lib";
import "@perxis-auto/shared";
import "../../../lib/constructor/mergeConstructor.js";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import "../../../config/env.js";
import "../../../config/events.js";
import "../../../lib/logger/index.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../../lib/store/createAppApi.js";
import "../../../lib/store/createAppAsyncThunk.js";
import "../../../lib/store/createAppSelector.js";
import "../../../lib/store/createAppSlice.js";
import "redux";
import "../../../lib/store/hooks/useAppDispatch.js";
import "../../../lib/store/hooks/useAppSelector.js";
import "../../../lib/store/hooks/useAppStore.js";
function findFieldKeysInGridItems(items) {
  const fieldKeys = [];
  items.forEach((item) => {
    if (item.fields) {
      fieldKeys.push(...Object.keys(item.fields));
    }
    if (item.referenceFields) {
      fieldKeys.push(...Object.keys(item.referenceFields));
    }
    if (instanceOfGrid(item)) {
      fieldKeys.push(...findFieldKeysInGridItems(item.items));
    }
  });
  return Array.from(fieldKeys);
}
function getConstructorFieldGroups(constructorGrid) {
  const referenceFields = findFieldKeysInGridItems(constructorGrid.items);
  const res = [
    .../* @__PURE__ */ new Set([
      ...Object.keys(constructorGrid.fields || {}),
      ...Object.keys(constructorGrid.referenceFields || {}),
      ...referenceFields
    ])
  ];
  return res;
}
export {
  getConstructorFieldGroups
};
